<template>
    <div>
        <div class="wrapper">
            <p style="margin: 50px 0; text-align: center; font-size: 16px;">Disponible prochainement</p>
        </div>

        <!-- <slide-up-modal
            v-if="documentFile"
            ref="documentCreationModal"
            modal-id="documentCreationModal"
            modal-title="Ajout de document interne"
            @modal-closed="hideDocumentCreationModal"
        >
            <p class="alert alert-danger" v-if="errorMessage">
                {{ errorMessage }}
            </p>

            <div class="form">
                <div class="form-group">
                    <label>Fichier sélectionné</label>
                    <p>{{ documentFile.name }}</p>
                </div>

                <div class="form-group">
                    <label for="document_name">Titre du document</label>
                    <input type="text" name="document_name" id="document_name" class="form-control" v-model="documentName" @keyup="errorMessage = null">
                </div>
            </div>

            <div class="actions" style="margin-top: 20px;">
                <button class="btn btn-complete btn-sm" @click="onFormSubmit">Valider</button>
                <button class="btn btn-default btn-sm" @click="hideDocumentCreationModal" style="margin-left: 5px;">Annuler</button>
            </div>
        </slide-up-modal>

        <div class="wrapper">
            <div class="creation-button-container">
                <button class="btn btn-complete" @click="$refs.fileInput.click()">
                    Ajouter un document
                </button>
            </div>

            <documents-list ref="documentsList"></documents-list>
        </div>

        <input type="file" accept=".jpg, .png, .jpeg, .pdf" ref="fileInput" class="hidden" @change="onFileInputChanged($event)"> -->
    </div>
</template>

<script type="text/babel">
import {mapState, mapActions} from "vuex"
import api from 'store/api'
import SlideUpModal from 'components/Modals/SlideUpModal'
import DocumentsList from './List'

export default {
    name: "InternalDocuments",
    
    components: {
        SlideUpModal,
        DocumentsList
    },

    data() {
        return {
            documentName: null,
            documentFile: null,
            errorMessage: null
        }
    },

    computed: {
        ...mapState('customer', {
            customerId: 'id'
        }),
    }, 

    methods: {
        hideDocumentCreationModal() {
            this.documentName = null
            this.documentFile = null
        },
        onFileInputChanged(event) {
            const documentFile = event.target.files[0] != undefined ? event.target.files[0] : null

            if (documentFile != null) {
                // Type validation
                const re = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
    
                if (!re.exec(documentFile.name)) {
                    this.addNotification('Type de fichier invalide : seuls les JPG, PNG et PDF sont acceptés', 'error')
    
                    return
                }
    
                // Size validation
                if (documentFile.size / 1024 / 1024 > 30) {
                    this.addNotification('Taille maximale de fichier dépassée', 'error')
    
                    return
                }
            }

            this.documentFile = documentFile
        },
        onFormSubmit() {
            if (!this.documentName || this.documentName.length === 0) {
                this.errorMessage = 'Le champ nom est obligatoire'

                return
            }

            this.performDocumentCreation()
        },
        performDocumentCreation() {
            let formData = new FormData()
            formData.append('document_name', this.documentName)
            formData.append('document_file', this.documentFile, this.documentFile.name)

            return api.storeCustomerInternalDocumentFile(this.customerId, formData)
                .then(response => {
                    this.hideDocumentCreationModal()
                    this.$refs.documentsList.fetchDocuments()
                })
                .catch(error => {
                    this.errorMessage = "Une erreur s'est produite. Merci de réessayer plus tard", 'error'
                })
        },
    }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 20px;

        .creation-button-container {
            display: flex;
            justify-content: center;
        }

        .form-group + .form-group {
            margin-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InternalDocuments/Root.vue